export default __webpack_public_path__ + "static/media/Luci.506376bb.png";